<template>
  <button
    v-if="visible"
    type="button"
    class="kefu-float"
    :aria-label="$t('Online CS')"
    @click="openKefu"
  >
    <span class="kefu-float-label">{{ $t('Online CS') }}</span>
    <span class="kefu-float-btn">
      <span class="kefu-float-pulse"></span>
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none" aria-hidden="true">
        <path d="M4.5 11.5a7.5 7.5 0 0 1 15 0v5.2a2.3 2.3 0 0 1-2.3 2.3h-1.4a1.2 1.2 0 0 1-1.2-1.2v-3.1c0-.7.5-1.2 1.2-1.2H19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M4.5 11.5v3.2c0 .7.5 1.2 1.2 1.2h1.5c.7 0 1.2-.5 1.2-1.2v-3.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M8.2 19.2c.8 1.2 2.2 2 3.8 2h.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </span>
  </button>
</template>

<script>
export default {
  name: 'KefuFloat',
  computed: {
    visible() {
      const path = (this.$route && this.$route.path) || '';
      if (path === '/kefu' || path === '/gamePage' || path.indexOf('/help') === 0) return false;
      const appInfo = this.$store.state.appInfo || {};
      return Number(appInfo.site_state) !== 0;
    },
  },
  methods: {
    openKefu() {
      if (this.$parent && typeof this.$parent.openKefu === 'function') {
        this.$parent.openKefu();
        return;
      }
      this.$router.push('/kefu').catch(() => {});
    },
  },
};
</script>

<style scoped>
.kefu-float {
  position: fixed;
  right: 12px;
  bottom: calc(78px + env(safe-area-inset-bottom));
  z-index: 190;
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.kefu-float-label {
  margin-right: -8px;
  padding: 7px 16px 7px 12px;
  border-radius: 999px 0 0 999px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #ead1b2;
  border-right: 0;
  color: #8f501f;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.4px;
  box-shadow: 0 6px 16px rgba(117, 73, 34, 0.12);
  white-space: nowrap;
}

.kefu-float-btn {
  position: relative;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a2e00;
  background: linear-gradient(145deg, #ffe082 0%, #d1a03e 55%, #b8860b 100%);
  box-shadow: 0 8px 18px rgba(209, 160, 62, 0.42);
}

.kefu-float-pulse {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  animation: kefu-pulse 1.6s infinite;
}

@keyframes kefu-pulse {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  70% { box-shadow: 0 0 0 8px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
</style>



// WEBPACK FOOTER //
// src/components/libs/KefuFloat.vue